import Vue from 'vue'
import VueRouter from 'vue-router'

import { index,rank,qa} from '../views/index'
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'Index',
    component: index
  },
  {
    path: '/rank',
    name: 'Rank',
    component: rank
  },
  {
    path: '/qa',
    name: 'Qa',
    component: qa    
  }
]

const router = new VueRouter({
  routes
})

export default router
